import React, { useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import { Badge, Tooltip } from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { routePaths } from "../../config/route-paths";
import { history } from "../../../helpers/history";
import { useDispatch, useSelector } from "react-redux";
import { getNotification } from "./model/notification.action";
import { appService } from "../../../services/app.service";

export default function NotificationIcon() {
  const dispatch=useDispatch();
  let labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.ALERT_AND_NOTIFICATION
  );
  const [redDot, setRedDot] = React.useState(false);
  let saId = useSelector((store) => store?.meterDetails?.getSaInfo?.saId);
  let accountId = useSelector((store) => store?.meterDetails?.accountId);
  let customerClassCd = useSelector(
    (store) => store?.meterDetails?.customerClassCd
  );
  let notification = useSelector((store) => store?.notificationDot?.data);
  let unreadMeter = localStorage.getItem("unreadMeter");
  let unreadBill = localStorage.getItem("unreadBill");
  let unreadAnnouncement = localStorage.getItem("unreadAnnouncement");
  let unreadPrepaidLowBalance = localStorage.getItem("unreadPrepaidLowBalance");
  let unreadPrepaidAccountCharge = localStorage.getItem("unreadPrepaidAccountCharge");
  let unreadPrepaidMinimumBalance = localStorage.getItem("unreadPrepaidMinimumBalance");
  let unreadUsageAlerts = localStorage.getItem("unreadUsageAlerts");
  useEffect(() => {
    unreadMeter = JSON.parse(unreadMeter);
    unreadBill = JSON.parse(unreadBill);
    unreadAnnouncement = JSON.parse(unreadAnnouncement);
    unreadPrepaidLowBalance = JSON.parse(unreadPrepaidLowBalance);
    unreadPrepaidAccountCharge = JSON.parse(unreadPrepaidAccountCharge);
    unreadPrepaidMinimumBalance = JSON.parse(unreadPrepaidMinimumBalance);
    unreadUsageAlerts=JSON.parse(unreadUsageAlerts);
    
    if (
      notification?.Meter === true ||
      notification?.Bill === true ||
      notification?.Outage === true ||
      notification?.Announcements === true ||
      notification?.PrepaidLowBalance === true ||
      notification?.PrepaidAccountCharge === true ||
      notification?.PrepaidMinimumBalance === true ||
      notification?.["AutoPay-PaymentSuccess"] === true || 
      notification?.["AutoPay-PaymentTechError"] === true ||
      notification?.["AutoPay-PaymentCancel"] === true ||
      notification?.["AutoPay-PaymentAdditionalCharge"] === true ||
      notification?.DailyUsage ||
      notification?.MonthlyUsage ||
      unreadMeter?.length > 0||
      unreadBill?.length > 0 ||
      unreadAnnouncement?.length > 0 ||
      unreadPrepaidLowBalance?.length > 0 ||
      unreadPrepaidAccountCharge?.length > 0 ||
      unreadPrepaidMinimumBalance?.length > 0 ||
      unreadUsageAlerts?.length > 0
    ) {
      setRedDot(true);
    }else{
        setRedDot(false)
      }
   
  }, [notification?.Meter,
      notification?.Bill,
      notification?.["AutoPay-PaymentSuccess"],
      notification?.["AutoPay-PaymentTechError"],
      notification?.["AutoPay-PaymentCancel"],
      notification?.["AutoPay-PaymentAdditionalCharge"],
      notification?.Announcements,
      notification?.PrepaidLowBalance,
      notification?.PrepaidAccountCharge,
      notification?.PrepaidMinimumBalance,
      notification?.DailyUsage,
      notification?.MonthlyUsage,
      redDot
    ]);
  useEffect(() => {
    if (saId && accountId && customerClassCd) {
      appService
      .getNotification(saId,accountId,customerClassCd)
      .then((response) => {
          dispatch(getNotification(response.data.notificationDot))
      })
    }
  }, [saId, accountId, customerClassCd]);
  return (
    <Tooltip title={labels?.NOTIFICATION_TOOLTIP} arrow>
      <IconButton
        onClick={() => {
          history.push(routePaths.ALERTS_AND_NOTIFICATION);
        }}
      >
        <Badge
          variant="dot"
          overlap="circle"
          color="secondary"
          invisible={!redDot}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
